import { Stack, Title } from '@mantine/core'
import { ZenteraLogo } from '@shared/components/zentera-logo/zentera-logo'

export const Logo = () => (
  <Stack gap={0}>
    <ZenteraLogo />
    <Title order={2} fz='2.1rem' c='var(--mantine-color-black)'>
      Grower Gateway
    </Title>
  </Stack>
)
